__turbopack_context__.v({
  "listItem": "Legal-module__QXACAW__listItem",
  "unorderedList": "Legal-module__QXACAW__unorderedList",
});
